import { createGlobalStyle } from "styled-components"

const Typography = createGlobalStyle`


h2 {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  margin-bottom: 1.25rem;
  font-family: "aviano-flare", sans-serif;
  font-weight: 700;
  font-style: normal;
  text-rendering: optimizeLegibility;
  font-size: 1.8rem;
  line-height: 1.1;
  letter-spacing: 0.15rem;
}
h3 {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  margin-bottom: 1.25rem;
  font-family: "aviano-flare", sans-serif;
  font-weight: 700;
  font-style: normal;
  text-rendering: optimizeLegibility;
  font-size: 1.6rem;
  line-height: 1.1;
  letter-spacing: 0.15rem;
  text-shadow: 1px 1px 1px var(--black);
}
h4 {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  margin-bottom: 1rem;
  font-family: "aviano-flare", sans-serif;
  font-weight: 700;   
  font-style: normal;
  text-rendering: optimizeLegibility;
  font-size: 1.4rem;
  line-height: 1.1;
  letter-spacing: 0.1rem;
  text-shadow: 1px 1px 1px var(--black);
}
h5 {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  margin-bottom: 1rem;
  color: inherit;
  font-family: "aviano-flare", sans-serif;
  font-weight: 700;
  font-style: normal;
  text-rendering: optimizeLegibility;
  font-size: 1.2rem;
  line-height: 1.1;
  letter-spacing: 0.1rem;
  text-shadow: 1px 1px 1px var(--black);
}

h6 {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  margin-bottom: 0.85rem;
  color: inherit;
  font-family: "aviano-flare", sans-serif;
  font-weight: 700;
  font-style: normal;
  text-rendering: optimizeLegibility;
  font-size: 1rem;
  line-height: 1.1;
}
p {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  margin-bottom: 0.85rem;
  font-family: "futura-pt", sans-serif;
  font-weight: 400;
  font-style: normal;
  text-rendering: optimizeLegibility;
  font-size: 1.4rem;
  line-height: 1.1;
}
a {
  text-decoration: none;
}
`

export default Typography
